import { render, staticRenderFns } from "./Coordinadores.vue?vue&type=template&id=9be65eae&scoped=true"
import script from "./Coordinadores.vue?vue&type=script&lang=js"
export * from "./Coordinadores.vue?vue&type=script&lang=js"
import style0 from "./Coordinadores.vue?vue&type=style&index=0&id=9be65eae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9be65eae",
  null
  
)

export default component.exports